import * as diacritics from "diacritics";
import slugify from "slugify";
import _ from "./lodash";
var removeDiacritics = diacritics.remove;
export var replaceApostrophes = function (str) { return (str || "").replace(/[’ʻʼ]/g, "-"); };
export var stripAccents = function (str) {
    var reAccents = /[αàáâãäçəèéêëìíîi̇ïñòóôõöùúūûüýÿÀÁÂÃÄÇÈÉÊËÌÍÎİÏÑÒÓÔÕÖÙÚÛÜÝЎʻʼ]/g;
    var replacements = "[aaaaaaceeeeeiiiiiinooooouuuuuyyAAAAACEEEEIIIIINOOOOOUUUUYY'']";
    return str.replace(reAccents, function (match) { return replacements[reAccents.source.indexOf(match)]; });
};
export var cleanString = _.flow([
    replaceApostrophes,
    _.kebabCase,
    stripAccents,
    removeDiacritics,
    slugify,
]);
var getConjunctionString = function (currentIndex, numberOfWords) {
    var thereAreNoWords = numberOfWords === 0;
    var isFirstWord = currentIndex === 0;
    var isLastWord = currentIndex === numberOfWords - 1;
    var isOnlyWord = isFirstWord && isLastWord;
    var isSecondToLastWord = currentIndex === numberOfWords - 2;
    var isFirstAmongTwoWords = isFirstWord && isSecondToLastWord;
    if (thereAreNoWords || isOnlyWord || isLastWord) {
        return "";
    }
    if (isFirstAmongTwoWords) {
        return " and ";
    }
    if (isSecondToLastWord) {
        return ", and ";
    }
    return ", ";
};
export var joinWords = function () {
    var words = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        words[_i] = arguments[_i];
    }
    var numberOfWords = words.length;
    return words.reduce(function (acc, word, i) {
        return "" + acc + word + getConjunctionString(i, numberOfWords);
    }, "");
};
var removeFromAttributionDisplay = {
    copyrightSymbol: /^\s*\u{00A9}\s*|\u{00A9}|\s*\u{00A9}\s*$/gu,
    imageBy: /^\s*image by\s*/gi,
    photoBy: /^\s*photo by\s*/gi,
};
export var cleanAttributionDisplay = function (attribution) {
    return Object
        .values(removeFromAttributionDisplay)
        .reduce(function (acc, regex) { return acc.replace(regex, ""); }, attribution);
};
var matchExists = function (input, regex) {
    var match = input.match(regex);
    return match && match.length > 0 || false;
};
export var hasImage = function (html) {
    return matchExists(html, /<img[^>]+src=('|")[^'">]+/gm);
};
export var hasOpVideo = function (html) {
    return matchExists(html, /<[^>]+data-op-video-id=('|")[^'">]+/gm);
};



//////////////////
// WEBPACK FOOTER
// ./app/shared/utils/string.ts
// module id = bwFx
// module chunks = 2 3 4